export const environment = {
    production: true,
    nombre:"Homologación",
    url:"https://backend.homo.telepagos.com.ar/api/",
    urlDescarga:"https://backend.homo.telepagos.com.ar/"
  };
  